var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.987,
    height: 27,
    viewBox: "0 0 27.987 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(0 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M12.857,31.179a1.929,1.929,0,1,1-1.929-1.929A1.929,1.929,0,0,1,12.857,31.179Z",
    transform: "translate(-1.286 -3.858)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M28.607,31.179a1.929,1.929,0,1,1-1.929-1.929A1.929,1.929,0,0,1,28.607,31.179Z",
    transform: "translate(-3.536 -3.858)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M27,7.071H5.612l-.791-4.05a.964.964,0,0,0-.964-.771H0V4.179H3.067L6.75,22.692a.964.964,0,0,0,.964.771H25.071V21.535H8.5l-.79-3.857H25.071a.964.964,0,0,0,.964-.753l1.929-8.678A.964.964,0,0,0,27,7.071ZM24.3,15.75H7.347L6,9h19.8Z",
    transform: "translate(0 0)",
    fill: "#5d5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.d4f51b3fde48f9ec463d7c3a21ed6429.svg";
export { ForwardRef as ReactComponent };